import React, { useMemo } from "react";
import Avatar from "antd/lib/avatar";
import Popover from "antd/lib/popover";
import Tooltip from "antd/lib/tooltip";
import Badge from "antd/lib/badge";
import WidgetFilterLockIcon from "../../../../../assets/filterLockIcon.svg";
import WidgetFilter from "../../../../../assets/WidgetFilter.svg";
import filterWhite from "../../../../../assets/WhiteIcons/filterIconWhite.svg";
import { getBrands, getMtdYtdDuration } from "../../../../../redux/constants";
import { useSelector } from "react-redux";
import { getPaneIndex } from "../../../../../redux/constants";
import isEqual from "react-fast-compare";
import moment from "moment";

const WidgetHeaderFilters = ({
  data,
  section_index,
  widget_index,
  dashboard,
  sections,
  widgetData,
}) => {
  const Allbrands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);
  const allAttributes = useSelector(
    (state) => state?.attributes?.allAttributes
  );
  const PdfDownloadStatus = useSelector(
    (state) => state.PdfDownloadData.PdfDownloadStatus
  );
  const All_Share_attributes = useSelector(
    (state) => state.WidgetMaker.All_Share_attributes
  );
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const authParams = useSelector((state) => state.Authentication.authParams);
  const panes = useSelector((state) => state.Tab1.panes);
  const activeKey = useSelector((state) => state.Tab1.activeKey);
  const Section = useSelector((state) => state.Section.addSection);
  let index = getPaneIndex(panes, activeKey);
  const section1 = panes[index]?.section;
  const isScheduleReportOpen = useSelector(
    (state) => state?.ApiCall?.is_schedule_report_open
  );
  const templateDetails = useSelector((state) => state.Section.templateDetails);

  // const profileFilterList = useSelector(
  //   (state) => state?.apiCall?.profile_filter_list
  // );
  const profileFilterList =
    window.location.pathname?.split("/")?.[1] === "edit-dashboard" ||
    window.location.pathname?.split("/")?.[1] === "create-dashboard"
      ? templateDetails?.profile_filters_list
      : panes?.[index]?.profile_filters_list;

  const section =
    !PdfDownloadStatus && sections
      ? null
      : sections && !sections[0]?.section_metadata && PdfDownloadStatus
      ? sections
      : section1;

  let widget_brands =
    (dashboard || isScheduleReportOpen) &&
    !PdfDownloadStatus &&
    widgetData?.brand_ids;

  let widget_logical_brands =
    (dashboard || isScheduleReportOpen) &&
    !PdfDownloadStatus &&
    widgetData?.brand_groups;

  let finalBrand_list =
    (widget_brands || widget_logical_brands) && !PdfDownloadStatus
      ? getBrands(
          shareBrands ? shareBrands?.brand_groups : brandlogicalgroup,
          widget_brands,
          shareBrands ? shareBrands?.brand_list : Allbrands,
          widget_logical_brands
        )
      : null;

  //Dashboard view case

  const getViewDashboardBadgeCount = () => {
    let dateFilter = widgetData?.start_date ? 1 : 0;
    let brandFilter = widgetData?.brand_groups || widgetData?.brand_ids ? 1 : 0;
    let filters = widgetData?.filters
      ? widgetData?.filters?.filter((e) => e?.attribute !== "CreatedDate")
          ?.length
      : 0;
    let view_profile_filters = widgetData?.payload?.profile_filters ? 1 : 0;

    let badgeCount = dateFilter + brandFilter + filters + view_profile_filters;
    return badgeCount;
  };
  const badgeCount = useMemo(() => getViewDashboardBadgeCount(), [panes]);
  //Dashboard create/edit case

  const getCreateDashboardBadgeCount = () => {
    let dateFilter1 =
      !PdfDownloadStatus &&
      section_index !== null &&
      section_index !== undefined &&
      Section &&
      Section[0]?.id &&
      Section[section_index]?.data
        ? widgetData?.dateFilters || widgetData?.start_date
          ? 1
          : 0
        : 0;
    let brandFilter1 =
      !PdfDownloadStatus &&
      section_index !== null &&
      section_index !== undefined &&
      Section &&
      Section[0]?.id &&
      Section[section_index]?.data
        ? widgetData?.brandFilters || widgetData?.brands?.length
          ? 1
          : 0
        : 0;
    let filters1 =
      !PdfDownloadStatus &&
      section_index !== null &&
      section_index !== undefined &&
      Section &&
      Section[0]?.id &&
      Section[section_index]?.data
        ? widgetData?.filters?.length > 0
          ? widgetData?.filters?.filter(
              (e) =>
                e?.attribute !== "CreatedDate" && e?.attribute !== "BrandID"
            )?.length
          : 0
        : 0;

    // let edit_profile_filters =
    //   section_index >= 0
    //     ? Section?.[section_index]?.data?.[widget_index]?.payload
    //         ?.profile_filters
    //       ? Section?.[section_index]?.data?.[widget_index]?.payload
    //           ?.profile_filters ? 1 : 0
    //       : Section?.[section_index]?.data?.[widget_index]?.profile_filters
    //         ? 1 : 0
    //     : Section?.[0]?.data?.[widget_index]?.payload?.profile_filters
    //     ? Section?.[0]?.data?.[widget_index]?.payload?.profile_filters ? 1 : 0
    //     : Section?.[0]?.data?.[widget_index]?.profile_filters ? 1 : 0;

    let edit_profile_filters =
      section_index >= 0
        ? Section?.[section_index]?.data?.[widget_index]?.profile_filters
          ? 1
          : 0
        : Section?.[0]?.data?.[widget_index]?.profile_filters
        ? 1
        : 0;

    // console.log("edit case",Section, edit_profile_filters);
    let badgeCount1 =
      dateFilter1 + brandFilter1 + filters1 + edit_profile_filters;
    return badgeCount1;
  };
  const badgeCount1 = useMemo(() => getCreateDashboardBadgeCount(), [Section]);
  //Dashboard share case
  const getShareDashboardBadgeCount = () => {
    let dateFilter2 = widgetData?.start_date ? 1 : 0;
    let filters2 = widgetData?.filters ? widgetData?.filters : [];

    let brandFilter2 = widgetData?.brand_groups ? 1 : 0;
    let brandFilter3 = widgetData?.brand_ids ? 1 : 0;

    let share_profile_filters = widgetData?.profile_filters ? 1 : 0;

    let sharebadgeCount =
      dateFilter2 +
      (brandFilter2 ? brandFilter2 : brandFilter3) +
      filters2?.length +
      share_profile_filters;

    return sharebadgeCount;
  };
  const sharebadgeCount = useMemo(
    () => shareBrands && getShareDashboardBadgeCount(),
    [shareBrands]
  );

  return (
    <>
      {sharebadgeCount
        ? sections &&
          // !section_index &&
          // sections[0]?.widgets &&
          // sections[0]?.widgets[widget_index] &&
          sharebadgeCount > 0 && (
            <>
              {PdfDownloadStatus ? (
                ""
              ) : (
                <>
                  {shareTemplateData?.["show_filters"] ? (
                    <Popover
                      placement="leftTop"
                      content={() => (
                        <div
                          className="custom_scroll p-2"
                          style={{
                            maxWidth: "27rem",
                            maxHeight: "23rem",
                            overflow: "auto",
                            scrollBehavior: "smooth",
                          }}
                        >
                          <div className="mb-2">
                            {finalBrand_list && (
                              <p className="mb-0 text-white">
                                <strong>Brands</strong>
                              </p>
                            )}

                            <span className="font-weight-light">
                              {finalBrand_list &&
                                finalBrand_list?.columns?.map((el, index) => (
                                  <span
                                    key={index}
                                    style={{
                                      color: "#fff",
                                      maxHeight: "20rem",
                                      overflow: "auto",
                                    }}
                                  >
                                    {(index ? ", " : "") +
                                      el?.brand_friendly_name}
                                  </span>
                                ))}
                            </span>
                            {/* <span className="font-weight-light text-white">
                          {sections[section_index >=0 ? section_index : 0]?.widgets[widget_index]
                            ?.brand_list?.columns?.length > 4 &&
                            ` , +${
                              sections[section_index >=0 ? section_index : 0]?.widgets[widget_index]
                                ?.brand_list?.columns?.length - 4
                            }`}
                        </span> */}
                          </div>
                          <div className="mb-2">
                            {sections &&
                              sections[section_index >= 0 ? section_index : 0]
                                ?.widgets[widget_index]?.start_date && (
                                <p className="mb-0 text-white">
                                  <strong>Duration</strong>
                                </p>
                              )}

                            <span className="font-weight-light text-white">
                              {sections &&
                              sections[section_index >= 0 ? section_index : 0]
                                ?.widgets[widget_index]?.relative_duration
                                ?.is_relative
                                ? ` ${
                                    moment(
                                      getMtdYtdDuration(
                                        sections[
                                          section_index >= 0 ? section_index : 0
                                        ]?.widgets[widget_index]
                                          ?.relative_duration?.relative_type
                                      )?.from
                                    ).format("MMM Do YYYY HH:mm") + " to "
                                  }
                                      ${moment(
                                        getMtdYtdDuration(
                                          sections[
                                            section_index >= 0
                                              ? section_index
                                              : 0
                                          ]?.widgets[widget_index]
                                            ?.relative_duration?.relative_type
                                        )?.to
                                      ).format("MMM Do YYYY HH:mm")}`
                                : sections &&
                                  sections[
                                    section_index >= 0 ? section_index : 0
                                  ]?.widgets[widget_index]?.start_date
                                ? ` ${
                                    moment(
                                      sections[
                                        section_index >= 0 ? section_index : 0
                                      ]?.widgets[widget_index]?.start_date
                                    ).format("MMM Do YYYY HH:mm") + " to "
                                  }
                                      ${moment(
                                        sections[
                                          section_index >= 0 ? section_index : 0
                                        ]?.widgets[widget_index]?.end_date
                                      ).format("MMM Do YYYY HH:mm")}`
                                : ""}
                            </span>
                          </div>
                          <div className="mb-1">
                            {sections &&
                              sections[
                                section_index >= 0 ? section_index : 0
                              ]?.widgets[widget_index]?.filters?.map(
                                (el, i) => {
                                  return (
                                    el?.attribute !== "CreatedDate" &&
                                    el?.attribute !== "BrandID" && (
                                      <div className="mb-2" key={i}>
                                        <p className="mb-0 text-white">
                                          <strong>
                                            {All_Share_attributes &&
                                            el?.attribute?.toLowerCase() ===
                                              "opinion_cid"
                                              ? "Opinions"
                                              : All_Share_attributes?.[
                                                  el?.attribute
                                                ]
                                              ? All_Share_attributes?.[
                                                  el?.attribute
                                                ]
                                              : All_Share_attributes[
                                                  el?.attribute?.endsWith("ID")
                                                    ? el?.attribute?.replace(
                                                        "ID",
                                                        ""
                                                      )
                                                    : el?.attribute?.toLowerCase()
                                                ]
                                              ? All_Share_attributes[
                                                  el?.attribute?.endsWith("ID")
                                                    ? el?.attribute?.replace(
                                                        "ID",
                                                        ""
                                                      )
                                                    : el?.attribute?.toLowerCase()
                                                ]
                                              : All_Share_attributes[
                                                  el?.attribute?.endsWith("ID")
                                                    ? el?.attribute?.replace(
                                                        "ID",
                                                        ""
                                                      )
                                                    : el?.attribute
                                                ]
                                              ? All_Share_attributes[
                                                  el?.attribute?.endsWith("ID")
                                                    ? el?.attribute?.replace(
                                                        "ID",
                                                        ""
                                                      )
                                                    : el?.attribute
                                                ]
                                              : el?.attribute ===
                                                "ChannelGroupID"
                                              ? "Channel"
                                              : el?.attribute?.toLowerCase() ===
                                                "categoryid"
                                              ? "Category"
                                              : el?.attribute?.toLowerCase() ===
                                                "subcategoryid_aug"
                                              ? "Sub Category"
                                              : el?.attribute?.toLowerCase() ===
                                                "subsubcategoryid"
                                              ? "Sub Sub Category"
                                              : el?.attribute?.replace(
                                                  "Type",
                                                  ""
                                                )}
                                          </strong>
                                        </p>
                                        {el?.type === "int" &&
                                          !Array.isArray(el?.columns) && (
                                            <span className="font-weight-light text-white">
                                              {el?.columns?.from +
                                                " - " +
                                                el?.columns?.to}
                                            </span>
                                          )}
                                        {Array.isArray(el?.columns) &&
                                          el?.columns?.map((e, index) => {
                                            return (
                                              <span
                                                key={index}
                                                className="font-weight-light"
                                                style={{
                                                  color:
                                                    e?.type === "include"
                                                      ? "#5ed66d"
                                                      : e?.type === "exclude"
                                                      ? "#fb7665"
                                                      : "#fff",
                                                }}
                                              >
                                                {(index ? ", " : "") +
                                                  (e?.display_name
                                                    ? e?.display_name
                                                    : e?.name === null
                                                    ? "Any"
                                                    : e?.name === 0
                                                    ? "No"
                                                    : e?.name === 1
                                                    ? "Yes"
                                                    : e?.name)}
                                              </span>
                                            );
                                          })}
                                      </div>
                                    )
                                  );
                                }
                              )}

                            {/* Shared Dashboard profile filters */}
                            {sections?.[section_index >= 0 ? section_index : 0]
                              ?.widgets?.[widget_index]?.profile_filters_flag &&
                              sections?.[section_index >= 0 ? section_index : 0]
                                ?.widgets?.[widget_index] &&
                              sections[section_index >= 0 ? section_index : 0]
                                ?.widgets[widget_index]?.profile_filters
                                ?.columns?.length && (
                                <>
                                  <p className="mb-0 text-white">
                                    <strong>Social Media Profiles</strong>
                                  </p>
                                  {sections?.[
                                    section_index >= 0 ? section_index : 0
                                  ]?.widgets?.[widget_index] &&
                                    sections?.[
                                      section_index >= 0 ? section_index : 0
                                    ]?.widgets?.[
                                      widget_index
                                    ]?.profile_filters?.columns?.map(
                                      (el, i) => {
                                        return (
                                          <div className="mb-2" key={i}>
                                            <span
                                              className="font-weight-light"
                                              style={{
                                                color:
                                                  el?.type === "include"
                                                    ? "#5ed66d"
                                                    : el?.type === "exclude" &&
                                                      "#fb7665",
                                              }}
                                            >
                                              {el?.display_name}
                                              {sections?.[
                                                section_index >= 0
                                                  ? section_index
                                                  : 0
                                              ]?.widgets?.[widget_index]
                                                ?.profile_filters?.columns
                                                ?.length -
                                                1 ===
                                              i
                                                ? ""
                                                : ","}
                                            </span>
                                          </div>
                                        );
                                      }
                                    )}
                                </>
                              )}

                            {/*Shared Dashboard No profile case */}
                            {sections?.[section_index >= 0 ? section_index : 0]
                              ?.widgets?.[widget_index]?.profile_filters_flag &&
                              !sections?.[
                                section_index >= 0 ? section_index : 0
                              ]?.widgets?.[widget_index]?.profile_filters && (
                                <>
                                  <p className="mb-0 text-white">
                                    <strong>Social Media Profiles</strong>
                                  </p>
                                  <div className="mb-2">
                                    <span
                                      className="font-weight-light"
                                      style={{
                                        color: "#fb7665",
                                      }}
                                    >
                                      No Profile
                                    </span>
                                  </div>
                                </>
                              )}
                          </div>
                        </div>
                      )}
                      color="#3B5175"
                      overlayClassName={
                        authParams?.theme_type === "1"
                          ? "darkTheme"
                          : "lightTheme"
                      }
                    >
                      <Badge
                        style={{ backgroundColor: "#185edf", fontSize: "1rem" }}
                        size="small"
                        count={sharebadgeCount ? sharebadgeCount : 0}
                      >
                        <button
                          className="ml-10 WidgetFilter_title pt-1 pb-1"
                          style={{
                            borderColor:
                              sections &&
                              sections[section_index >= 0 ? section_index : 0]
                                ?.widgets[widget_index]?.is_locked
                                ? "#EFE3C0"
                                : "#678bff33",
                          }}
                        >
                          <Avatar
                            shape="square"
                            size={16}
                            src={
                              sections[section_index >= 0 ? section_index : 0]
                                ?.widgets[widget_index]?.is_locked
                                ? WidgetFilterLockIcon
                                : authParams?.theme_type === "1"
                                ? filterWhite
                                : WidgetFilter
                            }
                            alt="Widget Filter 4"
                          />
                        </button>
                      </Badge>
                    </Popover>
                  ) : (
                    ""
                  )}
                </>
              )}
            </>
          )
        : !PdfDownloadStatus &&
          Section &&
          Section[0]?.id &&
          section_index !== null &&
          section_index !== undefined
        ? (Section[section_index]?.data[widget_index]?.filters?.length > 0 ||
            badgeCount1 > 0) && (
            <>
              <Tooltip
                placement="leftTop"
                overlayStyle={{
                  width:
                    data && data?.is_locked
                      ? "23rem"
                      : Section[section_index]?.data[widget_index]?.filters
                          ?.length ||
                        Section[section_index]?.data[widget_index]?.brandFilters
                      ? "22rem"
                      : "15rem",
                }}
                color="#3B5175"
                title={
                  <>
                    <div
                      className="custom_scroll"
                      style={{
                        maxWidth: "27rem",
                        maxHeight: "23rem",
                        overflow: "auto",
                        scrollBehavior: "smooth",
                      }}
                    >
                      {Section[section_index]?.data[widget_index]
                        ?.brandFilters && (
                        <div className="mb-2">
                          <p className="mb-0 text-white">
                            <strong>
                              {Section[section_index]?.data[widget_index]
                                ?.brandFilters?.attribute === "BrandID" &&
                                "Brands"}
                            </strong>
                          </p>
                          {Section[section_index]?.data[
                            widget_index
                          ]?.brandFilters?.columns?.map((el, index) => (
                            <span
                              key={index}
                              style={{
                                color: "#fff",
                                maxHeight: "20rem",
                                overflow: "auto",
                              }}
                            >
                              {(index ? ", " : "") + el?.brand_friendly_name}
                            </span>
                          ))}
                        </div>
                      )}
                      {Section[section_index]?.data[widget_index]?.duration
                        ?.from && (
                        <div className="mb-2">
                          <p className="mb-0 text-white">
                            <strong>Duration</strong>
                          </p>
                          <span>
                            {moment(
                              Section[section_index]?.data[widget_index]
                                ?.duration?.from
                            ).format("MMM Do YYYY HH:mm") + " to "}
                            {moment(
                              Section[section_index]?.data[widget_index]
                                ?.duration?.to
                            ).format("MMM Do YYYY HH:mm")}
                          </span>
                        </div>
                      )}
                      {/* Section[section_index]?.data[widget_index]?.is_locked
                          ? `Widget level filters are applied & locked. Global filters won't have any effect.`
                          : */}
                      {Section?.[section_index]?.data?.[widget_index] &&
                      Section[section_index]?.data[widget_index]?.filters
                        ?.length
                        ? Section?.[section_index]?.data?.[widget_index] &&
                          Section[section_index]?.data[
                            widget_index
                          ]?.filters?.map((el, i) => {
                            return (
                              el?.attribute !== "BrandID" &&
                              el?.attribute !== "CreatedDate" && (
                                <div className="mb-2" key={i}>
                                  <p className="mb-0 text-white">
                                    <strong>
                                      {el?.attribute === "BrandID"
                                        ? "Brands"
                                        : allAttributes &&
                                          allAttributes[el?.attribute]
                                        ? allAttributes[el?.attribute]
                                        : el?.attribute === "ChannelGroupID"
                                        ? "Channel"
                                        : el?.attribute?.toLowerCase() ===
                                          "categoryid"
                                        ? "Category"
                                        : el?.attribute?.toLowerCase() ===
                                          "subcategoryid_aug"
                                        ? "Sub Category"
                                        : el?.attribute?.toLowerCase() ===
                                          "subsubcategoryid"
                                        ? "Sub Sub Category"
                                        : el?.attribute?.replace("Type", "")}
                                    </strong>
                                  </p>
                                  {el?.type === "int" &&
                                    !Array.isArray(el?.columns) && (
                                      <span className="font-weight-light text-white">
                                        {el?.columns?.from +
                                          " - " +
                                          el?.columns?.to}
                                      </span>
                                    )}
                                  {el?.attribute === "CreatedDate" ? (
                                    <span
                                      className="font-weight-light"
                                      style={{
                                        color: "#fff",
                                      }}
                                    >
                                      {`${el?.columns?.from} - ${el?.columns?.to}`}
                                    </span>
                                  ) : (
                                    Array.isArray(el?.columns) &&
                                    el?.columns?.map((e, index) => {
                                      return (
                                        <span
                                          key={index}
                                          className="font-weight-light"
                                          style={{
                                            color:
                                              e?.type === "include"
                                                ? "#5ed66d"
                                                : e?.type === "exclude"
                                                ? "#fb7665"
                                                : "#fff",
                                          }}
                                        >
                                          {(index ? ", " : "") +
                                            (e?.display_name
                                              ? e?.display_name
                                              : e?.name === null
                                              ? "Any"
                                              : e?.name === 0
                                              ? "No"
                                              : e?.name === 1
                                              ? "Yes"
                                              : e?.name)}
                                        </span>
                                      );
                                    })
                                  )}
                                </div>
                              )
                            );
                          })
                        : ` `}

                      {/* Create dashboard*/}
                      {Section[section_index >= 0 ? section_index : 0]?.data[
                        widget_index
                      ]?.profile_filters_flag &&
                      Section[section_index >= 0 ? section_index : 0]?.data[
                        widget_index
                      ]?.profile_filters?.columns?.length
                        ? Section[section_index >= 0 ? section_index : 0]?.data[
                            widget_index
                          ]?.profile_filters?.columns?.length && (
                            <>
                              <p className="mb-0 text-white">
                                <strong>Social Media Profiles</strong>
                              </p>
                              {Section?.[section_index >= 0 ? section_index : 0]
                                ?.data?.[widget_index] &&
                                Section[
                                  section_index >= 0 ? section_index : 0
                                ]?.data[
                                  widget_index
                                ]?.profile_filters?.columns?.map((el, i) => {
                                  return (
                                    <div className="mb-2" key={i}>
                                      <span
                                        className="font-weight-light"
                                        style={{
                                          color:
                                            el?.type === "include"
                                              ? "#5ed66d"
                                              : el?.type === "exclude" &&
                                                "#fb7665",
                                        }}
                                      >
                                        {el?.display_name}
                                        {Section[section_index]?.data[
                                          widget_index
                                        ]?.profile_filters?.columns?.length -
                                          1 ===
                                        i
                                          ? ""
                                          : ","}
                                      </span>
                                    </div>
                                  );
                                })}
                            </>
                          )
                        : Section[section_index >= 0 ? section_index : 0]?.data[
                            widget_index
                          ]?.profile_filters_flag &&
                          Section?.[section_index >= 0 ? section_index : 0]
                            ?.data[widget_index]?.profile_filters_list?.length >
                            0 &&
                          profileFilterList && (
                            <>
                              <p className="mb-0 text-white">
                                <strong>Social Media Profiles</strong>
                              </p>
                              <div className="mb-2">
                                <span
                                  className="font-weight-light"
                                  style={{
                                    color: "#5ed66d",
                                  }}
                                >
                                  {profileFilterList[0]?.name}
                                </span>
                              </div>
                            </>
                          )}

                      {/* Create / Edit Case No profile case */}
                      {Section[section_index >= 0 ? section_index : 0]?.data[
                        widget_index
                      ]?.profile_filters_flag &&
                        !Section[section_index >= 0 ? section_index : 0]?.data[
                          widget_index
                        ]?.profile_filters && (
                          <>
                            <p className="mb-0 text-white">
                              <strong>Social Media Profiles</strong>
                            </p>
                            <div className="mb-2">
                              <span
                                className="font-weight-light"
                                style={{
                                  color: "#fb7665",
                                }}
                              >
                                No Profile
                              </span>
                            </div>
                          </>
                        )}
                    </div>
                  </>
                }
              >
                <Badge
                  style={{ backgroundColor: "#185edf", fontSize: "1rem" }}
                  size="small"
                  count={badgeCount1 ? badgeCount1 : 0}
                >
                  <button
                    className="WidgetFilter_title pt-1 pb-1 ml-2"
                    style={{
                      borderColor:
                        Section &&
                        Section[section_index]?.data[widget_index]?.is_locked
                          ? "#EFE3C0"
                          : "#678bff33",
                    }}
                  >
                    <Avatar
                      shape="square"
                      size={16}
                      src={
                        Section[section_index]?.data[widget_index]?.is_locked
                          ? WidgetFilterLockIcon
                          : authParams?.theme_type === "1"
                          ? filterWhite
                          : WidgetFilter
                      }
                      alt="Widget Filter 1"
                    />
                  </button>
                </Badge>
                {/* <Badge
                      style={{
                        backgroundColor: "#185edf",
                        fontSize: "1rem",
                      }}
                      size="small"
                      count={finalFilters?.length ? finalFilters?.length : 0}
                    >
                      <button
                        className={`WidgetFilter ${
                          data && data?.is_locked ? "locked" : ""
                        }`}
                        style={{
                          borderColor:
                            data && data?.is_locked ? "#EFE3C0" : "#678bff33",
                        }}
                        onClick={() => handleFilter()}
                      >
                        {
                          <>
                            <Avatar
                              shape="square"
                              size="small"
                              src={
                                data && data?.is_locked
                                  ? WidgetFilterLockIcon
                                  : WidgetFilter
                              }
                              alt="section Filter"
                            />
                          </>
                        }
                      </button>
                    </Badge> */}
              </Tooltip>
            </>
          )
        : section_index !== null &&
          section_index !== undefined &&
          section_index >= 0
        ? sections[section_index]?.widgets &&
          sections[section_index]?.widgets[widget_index] &&
          badgeCount > 0 && (
            <>
              {PdfDownloadStatus ? (
                ""
              ) : (
                <>
                  <Tooltip
                    placement="rightTop"
                    overlayStyle={{
                      width:
                        data && data?.is_locked
                          ? "23rem"
                          : Section[section_index]?.data[widget_index]?.filters
                              ?.length || finalBrand_list
                          ? "22rem"
                          : "15rem",
                    }}
                    color="#3B5175"
                    title={
                      <div
                        className="custom_scroll"
                        style={{
                          maxWidth: "27rem",
                          maxHeight: "23rem",
                          overflow: "auto",
                          scrollBehavior: "smooth",
                        }}
                      >
                        <div className="mb-2">
                          {finalBrand_list && (
                            <p className="mb-0 text-white">
                              <strong>Brands</strong>
                            </p>
                          )}
                          <span className="font-weight-light text-white">
                            {finalBrand_list &&
                            sections[section_index]?.widgets[widget_index]
                              ?.brand_list?.columns?.length ===
                              Allbrands?.length &&
                            Allbrands?.length !== undefined
                              ? "All Brands selected"
                              : finalBrand_list &&
                                finalBrand_list?.columns?.map((el, index) => (
                                  <span
                                    key={index}
                                    style={{
                                      color: "#fff",
                                      maxHeight: "20rem",
                                      overflow: "auto",
                                    }}
                                  >
                                    {(index ? ", " : "") +
                                      el?.brand_friendly_name}
                                  </span>
                                ))}
                          </span>
                          {/* <span className="font-weight-light text-white">
                            {sections[section_index]?.widgets[widget_index]
                              ?.brand_list?.columns?.length > 4 &&
                              ` , +${
                                sections[section_index]?.widgets[widget_index]
                                  ?.brand_list?.columns?.length - 4
                              }`}
                          </span> */}
                        </div>
                        <div className="mb-2">
                          {sections &&
                            sections[section_index]?.widgets[widget_index]
                              ?.start_date && (
                              <p className="mb-0 text-white">
                                <strong>Duration</strong>
                              </p>
                            )}

                          <span className="font-weight-light text-white">
                            {sections &&
                            sections[section_index]?.widgets[widget_index]
                              ?.relative_duration?.is_relative
                              ? `
                                ${
                                  moment(
                                    getMtdYtdDuration(
                                      sections[section_index]?.widgets[
                                        widget_index
                                      ]?.relative_duration?.relative_type
                                    )?.from
                                  ).format("MMM Do YYYY HH:mm") + " to "
                                }
                                ${moment(
                                  getMtdYtdDuration(
                                    sections[section_index]?.widgets[
                                      widget_index
                                    ]?.relative_duration?.relative_type
                                  )?.to
                                ).format("MMM Do YYYY HH:mm")}`
                              : sections[section_index]?.widgets[widget_index]
                                  ?.start_date
                              ? `
                                ${
                                  moment(
                                    sections[section_index]?.widgets[
                                      widget_index
                                    ]?.start_date
                                  ).format("MMM Do YYYY HH:mm") + " to "
                                }
                                ${moment(
                                  sections[section_index]?.widgets[widget_index]
                                    ?.end_date
                                ).format("MMM Do YYYY HH:mm")}`
                              : ""}
                          </span>
                        </div>
                        <div className="mb-1">
                          {sections &&
                            sections[section_index]?.widgets[
                              widget_index
                            ]?.filters?.map((el, i) => {
                              return (
                                el?.attribute !== "BrandID" &&
                                el?.attribute !== "CreatedDate" && (
                                  <div className="mb-2" key={i}>
                                    <p className="mb-0 text-white">
                                      <strong>
                                        {All_Share_attributes &&
                                        el?.attribute?.toLowerCase() ===
                                          "opinion_cid"
                                          ? "Opinions"
                                          : All_Share_attributes?.[
                                              el?.attribute
                                            ]
                                          ? All_Share_attributes?.[
                                              el?.attribute
                                            ]
                                          : All_Share_attributes[
                                              el?.attribute?.endsWith("ID")
                                                ? el?.attribute?.replace(
                                                    "ID",
                                                    ""
                                                  )
                                                : el?.attribute?.toLowerCase()
                                            ]
                                          ? All_Share_attributes[
                                              el?.attribute?.endsWith("ID")
                                                ? el?.attribute?.replace(
                                                    "ID",
                                                    ""
                                                  )
                                                : el?.attribute?.toLowerCase()
                                            ]
                                          : All_Share_attributes[
                                              el?.attribute?.endsWith("ID")
                                                ? el?.attribute?.replace(
                                                    "ID",
                                                    ""
                                                  )
                                                : el?.attribute
                                            ]
                                          ? All_Share_attributes[
                                              el?.attribute?.endsWith("ID")
                                                ? el?.attribute?.replace(
                                                    "ID",
                                                    ""
                                                  )
                                                : el?.attribute
                                            ]
                                          : el?.attribute === "ChannelGroupID"
                                          ? "Channel"
                                          : el?.attribute?.toLowerCase() ===
                                            "categoryid"
                                          ? "Category"
                                          : el?.attribute?.toLowerCase() ===
                                            "subcategoryid_aug"
                                          ? "Sub Category"
                                          : el?.attribute?.toLowerCase() ===
                                            "subsubcategoryid"
                                          ? "Sub Sub Category"
                                          : el?.attribute?.replace("Type", "")}
                                      </strong>
                                    </p>
                                    {el?.type === "int" &&
                                      !Array.isArray(el?.columns) && (
                                        <span className="font-weight-light text-white">
                                          {el?.columns?.from +
                                            " - " +
                                            el?.columns?.to}
                                        </span>
                                      )}
                                    {Array.isArray(el?.columns) &&
                                      el?.columns?.map((e, index) => {
                                        return (
                                          <span
                                            key={index}
                                            style={{
                                              color:
                                                e?.type === "include"
                                                  ? "#5ed66d"
                                                  : e?.type === "exclude"
                                                  ? "#fb7665"
                                                  : "#fff",
                                            }}
                                            className="font-weight-light"
                                          >
                                            {(index ? ", " : "") +
                                              (e?.display_name
                                                ? e?.display_name
                                                : e?.name === null
                                                ? "Any"
                                                : e?.name === 0
                                                ? "No"
                                                : e?.name === 1
                                                ? "Yes"
                                                : e?.name)}
                                          </span>
                                        );
                                      })}
                                  </div>
                                )
                              );
                            })}

                          {/* View Dashboard profile filters */}
                          {sections?.[section_index >= 0 ? section_index : 0]
                            ?.widgets?.[widget_index]?.profile_filters_flag &&
                            sections?.[section_index >= 0 ? section_index : 0]
                              ?.widgets?.[widget_index] &&
                            sections[section_index >= 0 ? section_index : 0]
                              ?.widgets[widget_index]?.profile_filters?.columns
                              ?.length && (
                              <>
                                <p className="mb-0 text-white">
                                  <strong>Social Media Profiles</strong>
                                </p>
                                {sections?.[
                                  section_index >= 0 ? section_index : 0
                                ]?.widgets?.[widget_index] &&
                                  sections?.[
                                    section_index >= 0 ? section_index : 0
                                  ]?.widgets?.[
                                    widget_index
                                  ]?.profile_filters?.columns?.map((el, i) => {
                                    return (
                                      <div className="mb-2" key={i}>
                                        <span
                                          className="font-weight-light"
                                          style={{
                                            color:
                                              el?.type === "include"
                                                ? "#5ed66d"
                                                : el?.type === "exclude" &&
                                                  "#fb7665",
                                          }}
                                        >
                                          {el?.display_name}
                                          {sections?.[
                                            section_index >= 0
                                              ? section_index
                                              : 0
                                          ]?.widgets?.[widget_index]
                                            ?.profile_filters?.columns?.length -
                                            1 ===
                                          i
                                            ? ""
                                            : ","}
                                        </span>
                                      </div>
                                    );
                                  })}
                              </>
                            )}

                          {/*View  No profile case */}
                          {sections?.[section_index >= 0 ? section_index : 0]
                            ?.widgets?.[widget_index]?.profile_filters_flag &&
                            !sections?.[section_index >= 0 ? section_index : 0]
                              ?.widgets?.[widget_index]?.profile_filters && (
                              <>
                                <p className="mb-0 text-white">
                                  <strong>Social Media Profiles</strong>
                                </p>
                                <div className="mb-2">
                                  <span
                                    className="font-weight-light"
                                    style={{
                                      color: "#fb7665",
                                    }}
                                  >
                                    No Profile
                                  </span>
                                </div>
                              </>
                            )}
                        </div>
                      </div>
                    }
                  >
                    <Badge
                      style={{
                        backgroundColor: "#185edf",
                        fontSize: "1rem",
                      }}
                      size="small"
                      count={badgeCount ? badgeCount : 0}
                    >
                      <button
                        className="WidgetFilter_title pt-1 pb-1 ml-2"
                        style={{
                          borderColor:
                            sections &&
                            sections[section_index]?.widgets[widget_index]
                              ?.is_locked
                              ? "#EFE3C0"
                              : "#678bff33",
                        }}
                      >
                        <Avatar
                          shape="square"
                          size={16}
                          src={
                            sections[section_index]?.widgets[widget_index]
                              ?.is_locked
                              ? WidgetFilterLockIcon
                              : authParams?.theme_type === "1"
                              ? filterWhite
                              : WidgetFilter
                          }
                          alt="Widget Filter 2"
                        />
                      </button>
                    </Badge>
                  </Tooltip>
                </>
              )}
            </>
          )
        : section &&
          section[0]?.widgets &&
          section[0]?.widgets[widget_index] &&
          badgeCount > 0 && (
            <>
              {PdfDownloadStatus ? (
                ""
              ) : (
                <>
                  <Tooltip
                    placement="leftTop"
                    overlayStyle={{
                      width:
                        data && data?.is_locked
                          ? "23rem"
                          : Section[section_index]?.data[widget_index]?.filters
                              ?.length
                          ? "22rem"
                          : "15rem",
                    }}
                    color="#3B5175"
                    title={
                      <div
                        className="custom_scroll"
                        style={{
                          maxWidth: "27rem",
                          maxHeight: "23rem",
                          overflow: "auto",
                          scrollBehavior: "smooth",
                        }}
                      >
                        <div className="mb-2">
                          {finalBrand_list && (
                            <p className="mb-0 text-white">
                              <strong>Brands</strong>
                            </p>
                          )}
                          <span className="font-weight-light text-white">
                            {finalBrand_list &&
                            section[0]?.widgets[widget_index]?.brand_list
                              ?.columns?.length === Allbrands?.length &&
                            Allbrands?.length !== undefined
                              ? "All Brands selected"
                              : finalBrand_list &&
                                finalBrand_list?.columns?.map((el, index) => (
                                  <span
                                    key={index}
                                    style={{
                                      color: "#fff",
                                      maxHeight: "20rem",
                                      overflow: "auto",
                                    }}
                                  >
                                    {(index ? ", " : "") +
                                      el?.brand_friendly_name}
                                  </span>
                                ))}
                          </span>
                          {/* <span className="font-weight-light text-white">
                                                     {sections[section_index]?.widgets[widget_index]
                            ?.brand_list?.columns?.length > 4 &&
                            ` , +${
                             section[0]?.widgets[widget_index]
                                ?.brand_list?.columns?.length - 4
                            }`}
                        </span> */}
                        </div>
                        <div className="mb-2">
                          {section[0] &&
                            section[0]?.widgets[widget_index]?.start_date && (
                              <p className="mb-0 text-white">
                                <strong>Duration</strong>
                              </p>
                            )}

                          <span className="font-weight-light text-white">
                            {section[0] &&
                            section[0]?.widgets[widget_index]?.relative_duration
                              ?.is_relative
                              ? `
                                ${
                                  moment(
                                    getMtdYtdDuration(
                                      section[0]?.widgets[widget_index]
                                        ?.relative_duration?.relative_type
                                    )?.from
                                  ).format("MMM Do YYYY HH:mm") + " to "
                                }
                                ${moment(
                                  getMtdYtdDuration(
                                    section[0]?.widgets[widget_index]
                                      ?.relative_duration?.relative_type
                                  )?.to
                                ).format("MMM Do YYYY HH:mm")}`
                              : section[0]?.widgets[widget_index]?.start_date
                              ? `
                                ${
                                  moment(
                                    section[0]?.widgets[widget_index]
                                      ?.start_date
                                  ).format("MMM Do YYYY HH:mm") + " to "
                                }
                                ${moment(
                                  section[0]?.widgets[widget_index]?.end_date
                                ).format("MMM Do YYYY HH:mm")}`
                              : ""}
                          </span>
                        </div>
                        <div className="mb-1">
                          {section[0] &&
                            section[0]?.widgets[widget_index]?.filters?.map(
                              (el, i) => {
                                return (
                                  el?.attribute !== "CreatedDate" &&
                                  el?.attribute !== "BrandID" && (
                                    <div className="mb-2" key={i}>
                                      <p className="mb-0 text-white">
                                        <strong>
                                          {All_Share_attributes &&
                                          el?.attribute?.toLowerCase() ===
                                            "opinion_cid"
                                            ? "Opinions"
                                            : All_Share_attributes?.[
                                                el?.attribute
                                              ]
                                            ? All_Share_attributes?.[
                                                el?.attribute
                                              ]
                                            : All_Share_attributes[
                                                el?.attribute?.endsWith("ID")
                                                  ? el?.attribute?.replace(
                                                      "ID",
                                                      ""
                                                    )
                                                  : el?.attribute?.toLowerCase()
                                              ]
                                            ? All_Share_attributes[
                                                el?.attribute?.endsWith("ID")
                                                  ? el?.attribute?.replace(
                                                      "ID",
                                                      ""
                                                    )
                                                  : el?.attribute?.toLowerCase()
                                              ]
                                            : All_Share_attributes[
                                                el?.attribute?.endsWith("ID")
                                                  ? el?.attribute?.replace(
                                                      "ID",
                                                      ""
                                                    )
                                                  : el?.attribute
                                              ]
                                            ? All_Share_attributes[
                                                el?.attribute?.endsWith("ID")
                                                  ? el?.attribute?.replace(
                                                      "ID",
                                                      ""
                                                    )
                                                  : el?.attribute
                                              ]
                                            : el?.attribute === "ChannelGroupID"
                                            ? "Channel"
                                            : el?.attribute?.toLowerCase() ===
                                              "categoryid"
                                            ? "Category"
                                            : el?.attribute?.toLowerCase() ===
                                              "subcategoryid_aug"
                                            ? "Sub Category"
                                            : el?.attribute?.toLowerCase() ===
                                              "subsubcategoryid"
                                            ? "Sub Sub Category"
                                            : el?.attribute?.replace(
                                                "Type",
                                                ""
                                              )}
                                        </strong>
                                      </p>
                                      {el?.type === "int" &&
                                        !Array.isArray(el?.columns) && (
                                          <span className="font-weight-light text-white">
                                            {el?.columns?.from +
                                              " - " +
                                              el?.columns?.to}
                                          </span>
                                        )}
                                      {Array.isArray(el?.columns) &&
                                        el?.columns?.map((e, index) => {
                                          return (
                                            <span
                                              key={index}
                                              className="font-weight-light"
                                              style={{
                                                color:
                                                  e?.type === "include"
                                                    ? "#5ed66d"
                                                    : e?.type === "exclude"
                                                    ? "#fb7665"
                                                    : "#fff",
                                              }}
                                            >
                                              {(index ? ", " : "") +
                                                (e?.display_name
                                                  ? e?.display_name
                                                  : e?.name === null
                                                  ? "Any"
                                                  : e?.name === 0
                                                  ? "No"
                                                  : e?.name === 1
                                                  ? "Yes"
                                                  : e?.name)}
                                            </span>
                                          );
                                        })}
                                    </div>
                                  )
                                );
                              }
                            )}

                          {/* Edit Dashboard Profile Filters */}
                          {section?.[section_index >= 0 ? section_index : 0]
                            ?.widgets?.[widget_index]?.profile_filters_flag &&
                            section?.[section_index >= 0 ? section_index : 0]
                              ?.widgets?.[widget_index] &&
                            section[section_index >= 0 ? section_index : 0]
                              ?.widgets[widget_index]?.payload?.profile_filters
                              ?.columns?.length && (
                              <>
                                <p className="mb-0 text-white">
                                  <strong>Social Media Profiles</strong>
                                </p>
                                {section?.[
                                  section_index >= 0 ? section_index : 0
                                ]?.widgets?.[widget_index] &&
                                  section?.[
                                    section_index >= 0 ? section_index : 0
                                  ]?.widgets?.[
                                    widget_index
                                  ]?.payload?.profile_filters?.columns?.map(
                                    (el, i) => {
                                      return (
                                        <div className="mb-2" key={i}>
                                          <span
                                            className="font-weight-light"
                                            style={{
                                              color:
                                                el?.type === "include"
                                                  ? "#5ed66d"
                                                  : el?.type === "exclude" &&
                                                    "#fb7665",
                                            }}
                                          >
                                            {el?.display_name}
                                            {section?.[
                                              section_index >= 0
                                                ? section_index
                                                : 0
                                            ]?.widgets?.[widget_index]
                                              ?.profile_filters?.columns
                                              ?.length -
                                              1 ===
                                            i
                                              ? ""
                                              : ","}
                                          </span>
                                        </div>
                                      );
                                    }
                                  )}
                              </>
                            )}

                          {/*Edit dashboard No profile case */}
                          {section?.[section_index >= 0 ? section_index : 0]
                            ?.widgets?.[widget_index]?.profile_filters_flag &&
                            !section?.[section_index >= 0 ? section_index : 0]
                              ?.widgets?.[widget_index]?.payload
                              ?.profile_filters && (
                              <>
                                <p className="mb-0 text-white">
                                  <strong>Social Media Profiles</strong>
                                </p>
                                <div className="mb-2">
                                  <span
                                    className="font-weight-light"
                                    style={{
                                      color: "#fb7665",
                                    }}
                                  >
                                    No Profile
                                  </span>
                                </div>
                              </>
                            )}
                        </div>
                      </div>
                    }
                  >
                    <Badge
                      style={{ backgroundColor: "#185edf", fontSize: "1rem" }}
                      size="small"
                      count={badgeCount ? badgeCount : 0}
                    >
                      <button
                        className="WidgetFilter_title pt-1 pb-1 ml-2"
                        style={{
                          borderColor:
                            section &&
                            section[0]?.widgets[widget_index]?.is_locked
                              ? "#EFE3C0"
                              : "#678bff33",
                        }}
                      >
                        <Avatar
                          shape="square"
                          size={16}
                          src={
                            section[0]?.widgets[widget_index]?.is_locked
                              ? WidgetFilterLockIcon
                              : authParams?.theme_type === "1"
                              ? filterWhite
                              : WidgetFilter
                          }
                          alt="Widget Filter 3"
                        />
                      </button>
                    </Badge>
                  </Tooltip>
                </>
              )}
            </>
          )}
    </>
  );
};

export default React.memo(WidgetHeaderFilters, isEqual);
